import React, { PropsWithChildren } from "react"

export const Avatar: React.FC<PropsWithChildren<{src?: string}>> = ({src, children}) => {
  return (
    <div className='rounded-full overflow-hidden flex items-center bg-[#f5f5f5] hover:bg-neutral-200 active:bg-neutral-300 w-11 h-11 justify-center'>
      {!src && children}
      {src && <img src={src}/>}
    </div>
  )
} 